"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactAutosizeTextarea = _interopRequireDefault(require("react-autosize-textarea"));
var _tokens = require("../../../tokens");
var _interactive = require("../../../helpers/interactive");
var _hooks = require("../../../internal/hooks");
var _Icon = require("../../Icon");
var _PrefixSuffix = require("./PrefixSuffix");
var _ClearButton = require("./ClearButton");
var _constants = require("./constants");
var _hooks2 = require("./hooks");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledLabel = _styledComponents.default.label.withConfig({
  displayName: "StyledLabel",
  componentId: "sc-1wpl9rv-0"
})(["color:", ";font-size:", ";margin:0;"], _tokens.COLOR.GREY.DARK, _tokens.FONT.SIZE.M);
const StyledHint = _styledComponents.default.p.withConfig({
  displayName: "StyledHint",
  componentId: "sc-1wpl9rv-1"
})(["color:", ";font-size:", ";margin:0;"], _tokens.COLOR.GREY.DARK, _tokens.FONT.SIZE.S);
const StyledInput = _styledComponents.default.input.withConfig({
  displayName: "StyledInput",
  componentId: "sc-1wpl9rv-2"
})(["width:100%;background-color:", ";margin:12px 0 0;padding:", "px;border-radius:", ";border:2px solid ", ";outline:0;color:", ";font-size:", ";resize:none;", " &::-ms-clear{width:0;height:0;}", " ", " ", " ", ""], _ref => {
  let {
    $background
  } = _ref;
  return $background;
}, _constants.INPUT_PADDING, _tokens.BORDER.RADIUS.S, _tokens.COLOR.GREY.MEDIUM, _tokens.COLOR.BLACK, _tokens.FONT.SIZE.M, _interactive.interactiveBoxShadowStyles, _ref2 => {
  let {
    $width
  } = _ref2;
  return $width && `max-width: ${$width};`;
}, _ref3 => {
  let {
    $maxRows
  } = _ref3;
  return $maxRows && `max-height: ${`calc(${2 * (_constants.INPUT_PADDING + 2)}px + ${$maxRows} * 1.5em);`};`;
}, _ref4 => {
  let {
    $error
  } = _ref4;
  return $error && `
    border-color: ${_tokens.COLOR.STATE.ERROR};
  `;
}, _ref5 => {
  let {
    disabled
  } = _ref5;
  return disabled && `
    cursor: not-allowed;
    border-color: ${_tokens.COLOR.GREY.LIGHT};
  `;
});
const StyledError = _styledComponents.default.p.withConfig({
  displayName: "StyledError",
  componentId: "sc-1wpl9rv-3"
})(["color:", ";font-size:", ";margin:", "px 0 0;"], _tokens.COLOR.STATE.ERROR, _tokens.FONT.SIZE.XS, _constants.INPUT_GAP_BELOW);
const condensedLabelActiveTransform = `translate(0, -8px) scale(${parseInt(_tokens.FONT.SIZE.XS) / parseInt(_tokens.FONT.SIZE.M)})`;
const StyledWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-1wpl9rv-4"
})(["position:relative;text-align:left;", ""], _ref6 => {
  let {
    $hasLabel,
    $condensed
  } = _ref6;
  if (!$hasLabel) return `
        > *:first-child {
          margin-top: 0;
        }
      `;
  if ($condensed) return `
        margin: ${_tokens.GTR.S} 0;

        ${StyledInput} {
          padding: ${_tokens.GTR.M} ${_constants.INPUT_PADDING_CONDENSED}px ${_tokens.GTR.XS};
          margin: 0;
        }

        ${StyledLabel} {
          position: absolute;
          pointer-events: none;
          left: ${_constants.INPUT_PADDING_CONDENSED + 2}px;
          top: ${_tokens.GTR.S};
          transform: translate(0, 2px);
          transform-origin: 0 0;
          transition: transform 0.1s ease-in-out;

          + * {
            margin-top: ${_constants.INPUT_GAP_BELOW}px;
          }
        }

        ${StyledInput}:focus ~ ${StyledLabel},
        ${StyledInput}:not(:placeholder-shown) ~ ${StyledLabel} {
          transform: ${condensedLabelActiveTransform};
        }
        ${StyledInput}:not(:-ms-input-placeholder) + ${StyledLabel} {
          transform: ${condensedLabelActiveTransform};
        }

        ${StyledHint} {
          font-size: ${_tokens.FONT.SIZE.XS};
        }
      `;
  return `
      margin: ${_tokens.GTR.M} 0;
    `;
});
const StyledWarningIcon = (0, _styledComponents.default)(_Icon.WarningTriangleIcon).withConfig({
  displayName: "StyledWarningIcon",
  componentId: "sc-1wpl9rv-5"
})(["position:absolute;display:block;pointer-events:none;right:12px;margin-top:", "px;border-radius:0;z-index:1;", ":focus + &{display:none;}"], _ref7 => {
  let {
    $condensed
  } = _ref7;
  return $condensed ? -49 : -53;
}, StyledInput);

/**
## Usage

```jsx
import { Input } from '@farewill/ui'
```

### How to use this component

Use the text input components when you need to let users enter text. Use the basic component size for all customer-facing products. Use the multiline components when you need to let users enter text that’s longer than a single line.

You can use the Condensed component size for internal products where you need to save space.

#### Labels 

All text inputs must have visible labels; placeholder text is not an acceptable replacement for a label as it vanishes when users start typing. Labels should be short, direct and written in sentence case. 

#### Hint explanations 

Use hint input explanation under the label when you need to further explain something about the information required. This includes anything that would return as an error when completed. For example:

- how the information will be used
- where to find the information
- text limits
- give examples of the information 
- formatting guidance

#### Width

The width of text inputs is fluid and will fit the full width of the container they are placed into.

Use fixed width inputs for content that has a specific, known length, such as postcode input. On fixed width inputs, the width will remain fixed on all screens unless it is wider than the viewport, in which case it will shrink to fit.

_________________

<details> 
  <summary><b>Other ways to use text input</b></summary>

  <h3>Optional fields</h3> 

As a principle of best practice, text inputs should be required fields by default.  
Sometimes we may want to collect additional information to enhance the customer experience, e.g. asking for a customer’s ‘preferred name’. In this case we could use optional fields, but they must be clearly marked as **(optional)** in the label.

<h3>Disabled state</h3>

Disabled text input fields can confuse some users, so avoid them if possible. Use them when you want to indicate that the information entered cannot be changed. Only use disabled text input fields on internal tools and where research shows it’s useful. 

<h3>Prefixes and suffixes</h3>

Prefixes and suffixes are useful when there’s a commonly understood symbol or abbreviation for the type of information you’re asking for, like currencies and measurements. Always be specific about the information you need in the label as well.

They can be icons or a text string.

<h3>Clear</h3>

Use the clear variation when you need to provide users the options to quickly delete the text they’ve entered.


</details>





 */
// eslint-disable-next-line react/display-name
const Input = exports.Input = /*#__PURE__*/_react.default.forwardRef((_ref8, forwardedRef) => {
  let {
    label,
    hint,
    error,
    prefix,
    suffix,
    condensed,
    highlighted,
    disabled,
    optional,
    className,
    width,
    showClearButton,
    onClear,
    multiline,
    maxRows,
    tag,
    id: idProp,
    onChange,
    onFocus,
    ...props
  } = _ref8;
  const ref = forwardedRef || (0, _react.useRef)(null);
  const id = idProp || (0, _hooks.useUniqueId)();
  const labelId = `label-${id}`;
  const hintId = `hint-${id}`;
  const errorId = `error-${id}`;
  const hasErrorMessage = error && error !== true;
  const [errorTouched, onTouch] = (0, _hooks2.useErrorTouched)(error);
  const inputBackground = disabled ? _tokens.COLOR.GREY.LIGHT : highlighted ? _tokens.COLOR.STATE.HIGHLIGHT : _tokens.COLOR.WHITE;
  const widthString = typeof width === 'number' ? `${width}px` : width;
  let inputEl = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledInput, _extends({
    id: id,
    ref: ref,
    "aria-describedby": hint ? hintId : undefined,
    "aria-invalid": !!error,
    "aria-errormessage": hasErrorMessage || error === true && idProp ? errorId : undefined,
    as: tag || (multiline ? _reactAutosizeTextarea.default : 'input')
  }, props, {
    onChange: e => {
      onTouch();
      if (onChange) onChange(e);
    },
    onFocus: e => {
      onTouch();
      if (onFocus) onFocus(e);
    },
    $error: !!error,
    $width: widthString,
    $maxRows: !condensed && maxRows,
    $background: inputBackground,
    disabled: disabled,
    required: !optional
    /**
     * By specifying a single space as the placeholder we can use a css-only
     * solution to move the label on condensed inputs, which allows us to use the
     * input as a controlled or non-controlled component. This works on all our
     * supported browsers and does not effect screen reader output.
     */,
    placeholder: condensed ? ' ' : undefined
  })), hasErrorMessage && !errorTouched && /*#__PURE__*/_react.default.createElement(StyledWarningIcon, {
    color: _tokens.COLOR.STATE.ERROR,
    background: inputBackground,
    $condensed: !!condensed,
    "aria-hidden": true
  }));

  /**
   * Always wrap non-condensed inputs in InputPrefixSuffixWrapper to avoid the input
   * being re-mounted and losing focus when showClearButton is toggled or a prefix
   * or suffix is added or removed.
   */
  if (!condensed) {
    inputEl = /*#__PURE__*/_react.default.createElement(_PrefixSuffix.InputPrefixSuffixWrapper, {
      width: widthString
    }, prefix && /*#__PURE__*/_react.default.createElement(_PrefixSuffix.Prefix, null, prefix), (showClearButton || suffix) && /*#__PURE__*/_react.default.createElement(_PrefixSuffix.Suffix, null, showClearButton ? /*#__PURE__*/_react.default.createElement(_ClearButton.ClearButton, {
      onClear: onClear,
      inputRef: ref,
      "aria-describedby": label ? labelId : undefined
    }) : suffix), inputEl);
  }
  const labelEl = label && /*#__PURE__*/_react.default.createElement(StyledLabel, {
    id: labelId,
    htmlFor: id
  }, label, optional ? ' (optional)' : '');
  const hintEl = hint && /*#__PURE__*/_react.default.createElement(StyledHint, {
    id: hintId
  }, hint);
  const errorEl = hasErrorMessage && /*#__PURE__*/_react.default.createElement(StyledError, {
    id: errorId
  }, error);
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, {
    className: className,
    $condensed: !!condensed,
    $hasLabel: !!label
  }, condensed ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, inputEl, labelEl, errorEl, hintEl) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, labelEl, hintEl, inputEl, errorEl));
});